import { Component } from '@angular/core';
import { Observable, catchError, firstValueFrom, map, of, tap } from 'rxjs';
import { DialogCreaCfgAzioneEBuonaPraticaComponent } from 'src/app/page/configurazioni/cfg-azione-e-buona-pratica/dialog/dialog-crea-cfg-azione-e-buona-pratica/dialog-crea-cfg-azione-e-buona-pratica.component';
import { SelezioneElementiQuestionarioComponent } from '../../selezione-elementi-questionario.component';

@Component({
  selector: 'app-selezione-azioni-buonepratiche-policy',
  templateUrl: '../../selezione-elementi-questionario.component.html',
  styleUrls: ['../../selezione-elementi-questionario.component.scss'],
  standalone: false,
})
export class SelezioneAzioniBuonepratichePolicyComponent extends SelezioneElementiQuestionarioComponent {
  override editElementoListaChk(idAmbito: string, idTematica: string, azioneBP?: any): void {
    azioneBP = super.addSettoreElemento(azioneBP);
    const dialogCreaAzioneBP = this.dialog.open(DialogCreaCfgAzioneEBuonaPraticaComponent, {
      data: {
        azioneBP: azioneBP,
        idContest: this.idContest,
        idAmbito: idAmbito,
        idTematica: idTematica,
        contesto: 'policy',
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '75%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogCreaAzioneBP.afterClosed().subscribe((result) => {
      if (result) {
        this.spinnerOver.show();
        this.salvataggio(idAmbito, idTematica, azioneBP?.id);
      }
    });
  }

  async salvataggio(idAmbito: string, idTematica: string, idAzioneBP: string) {
    try {
      // Salvo i dati modificati
      await firstValueFrom(this.salva(true));

      // Get dei dati aggiornati
      await firstValueFrom(this._getAzioniBPPolicy());

      // Scroll all'elemento modificato
      setTimeout(() => {
        this.scrollToElement(idAmbito, idTematica, idAzioneBP);
      }, 0);
    } catch (error) {
      console.error(error);
    }
  }

  override addElementoListaChk(idAmbito: string, idTematica: string): void {
    // posso passare la stessa funzione poichè la gestione è identica, Cambia solameanete il passaggio del azioneBP
    // a vuoto nella creazione.
    this.editElementoListaChk(idAmbito, idTematica);
  }

  override salvaFigAz(
    idAmbito: string,
    idTematica: string,
    idAzioneBP: string,
    idFigAziendale: string,
  ): void {
    this.spinnerOver.show();
    this.policyService
      .putAssegnaFiguraAzioniBPPolicy(
        this.idContest,
        idAmbito,
        idTematica,
        idAzioneBP,
        idFigAziendale,
      )
      .subscribe({
        next: () => {
          this.salvataggio(idAmbito, idTematica, idAzioneBP);
        },
        error: (err) => {
          console.error(err);
          this.spinnerOver.hide();
        },
      });
  }

  private _getAzioniBPPolicy(): Observable<any> {
    this.spinnerOver.show();

    return this.policyService.getAzioniBPPolicy(this.idContest).pipe(
      tap((esito) => {
        this.objQuestionario = esito;
      }),
      catchError((err) => {
        console.error(err);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Errore nel recupero delle azioni e buone pratiche',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return of(null);
      }),
      tap({
        finalize: () => this.spinnerOver.hide(),
      }),
    );
  }

  override ctrStepper(msgChiave: string): boolean {
    return super.ctrStepper(msgChiave);
  }

  salva(noCtr?: boolean) {
    let azioneBPSelezionate = this.oggettoElementiSelezionati();

    if (!noCtr) {
      //Controllo se è stato selezionato almeno un azione buona pratica per tematica
      if (this.ctrElemChecked(azioneBPSelezionate, 'azione o buona pratica')) {
        return of(false);
      }
    }

    return this._salvaSurveyElemSel(azioneBPSelezionate);
  }

  private _salvaSurveyElemSel(azioneBPSelezionate: any): Observable<boolean> {
    if (this.idContest) {
      return this.policyService
        .putAzioniBPPolicySelezionati(this.idContest, azioneBPSelezionate)
        .pipe(
          map((result: any) => {
            this.utilityService.openSnackBar('Aggiornamento effettuato', '', {
              duration: 2000,
              panelClass: ['success-snackbar'],
            });

            this.salvato.emit();

            return true;
          }),
          catchError((err: any) => {
            console.error('Errore :', err);

            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: err?.error?.message || 'Errore salvataggio (sconosciuto)',
              bottoni: [{ nome_btn: 'Ok' }],
            });
            return of(false);
          }),
        );
    } else {
      return of(false);
    }
  }
}
